import { useEffect } from 'react'
import { useOrgStore } from '@/stores/orgStore'
import { useOrganizations } from '@/components/layout/team-switcher'

// eslint-disable-next-line react-refresh/only-export-components
export const useOrgValidator = () => {
  const { data: apiResponse } = useOrganizations()
  const { currentOrgId, currentUserLevel, setCurrentOrg } = useOrgStore()

  useEffect(() => {
    const validateOrg = () => {
      const organizations = apiResponse?.organizations || []

      if (organizations.length > 0 && currentOrgId) {
        const validOrg = organizations.find((org) => org.id === currentOrgId)

        if (!validOrg) {
          // Organization no longer exists in user's list
          const defaultOrg =
            organizations.find((org) => org.user_level === 3) || // External-level org
            organizations.find((org) => org.user_level === 2) ||
            organizations.find((org) => org.user_level === 1) ||
            organizations.find((org) => org.user_level === 0) ||
            organizations[0] // Fallback: First org
          if (defaultOrg) {
            setCurrentOrg(defaultOrg.id, defaultOrg.user_level)
            localStorage.setItem('currentOrgId', JSON.stringify(defaultOrg.id))
          }
        } else if (validOrg.user_level !== currentUserLevel) {
          // Update user level if changed
          setCurrentOrg(validOrg.id, validOrg.user_level)
        }
      }
    }

    validateOrg()
    const interval = setInterval(validateOrg, 30000)
    return () => clearInterval(interval)
  }, [apiResponse, currentOrgId, currentUserLevel, setCurrentOrg])
}

export const SecurityWrapper = ({
  children,
}: {
  children: React.ReactNode
}) => {
  useOrgValidator()
  return <>{children}</>
}
